import axios from "axios";
import appConfig from "../config/default";

const httpService = axios.create({});

httpService.interceptors.request.use(
  (request) => {
    try {
      const accessToken = localStorage.getItem("webTvUserToken");

      if (accessToken) {
        request.headers["Authorization"] = `Bearer ${accessToken}`;
      }

      request.headers["X-App-Identifier"] = "MNB-WebTV";

      return request;
    } catch (error) {
      console.log("ERROR on Intercepting Access Token" + error);
      return request;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpService.interceptors.response.use(
  (response) => response, // Directly return successful responses.
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
      try {
        const refreshToken = localStorage.getItem("webTvrefreshToken"); // Retrieve the stored refresh token.
        // Make a request to your auth server to refresh the token.
        const response = await axios.post(appConfig.API.REFRESH_TOKEN, {
          refreshToken,
        });

        const { data } = response.data;
        // Store the new access and refresh tokens.
        localStorage.setItem("webTvUserToken", data.accessToken);
        // Update the authorization header with the new access token.
        httpService.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.accessToken}`;
        return httpService(originalRequest); // Retry the original request with the new access token.
      } catch (refreshError) {
        // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
        console.error("Token refresh failed:", refreshError);
        localStorage.removeItem("webTvUserToken");
        localStorage.removeItem("webTvrefreshToken");

        //window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error); // For all other errors, return the error as is.
  }
);

export default httpService;
